module.exports = __webpack_public_path__ + "static/media/Schritt_4_Uebergabegespraech.5111ca8a.pdf";